import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { publicAPI } from '../services/api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api/v1';

// Get logged-in user profile from spa_token
async function fetchLoggedInUser() {
  const token = localStorage.getItem('spa_token');
  if (!token) return null;
  try {
    const res = await fetch(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.data || data.user || data;
  } catch { return null; }
}

const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:5001';

const TYPE_COLORS = {
  bootcamp:     '#e8a43a',
  workshop:     '#4e9cf5',
  certification:'#3ecf8e',
  course:       '#a78bfa',
  mentorship:   '#f472b6',
};

const MODE_ICONS = { online:'Remote', physical:'In-Person', hybrid:'Hybrid', in_person:'In-Person' };

function resolveMedia(url) {
  if (!url) return null;
  return url.startsWith('http') ? url : `${MEDIA_URL}${url}`;
}

// â”€â”€ Enroll Modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€


// â”€â”€ Main Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export default function ProgramDetailPage() {
  const { slug }    = useParams();
  const navigate    = useNavigate();
  const [program, setProgram]     = useState(null);
  const [loading, setLoading]     = useState(true);
  const [notFound, setNotFound]   = useState(false);

  useEffect(() => {
    setLoading(true);
    publicAPI.programBySlug(slug)
      .then(r => { setProgram(r.data?.data); setLoading(false); })
      .catch(err => {
        if (err.response?.status === 404) setNotFound(true);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return (
    <div style={{ minHeight:'80vh', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--t-muted)' }}>Loadingâ€¦</div>
  );

  if (notFound || !program) return (
    <div style={{ minHeight:'80vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:16 }}>
      <div style={{ fontSize:'3rem', opacity:0.2 }}>â—</div>
      <div style={{ color:'var(--t-muted)', fontSize:'1.1rem' }}>Program not found</div>
      <Link to="/academy" className="btn btn-outline"> Back to Programs</Link>
    </div>
  );

  const color    = TYPE_COLORS[program.program_type] || TYPE_COLORS[program.type] || 'var(--gold)';
  const src      = resolveMedia(program.media_url);
  const cohorts  = program.cohorts || [];
  const upcoming = cohorts.filter(c => c.status === 'upcoming');
  const objectives    = Array.isArray(program.objectives)    ? program.objectives    : [];
  const outcomes      = Array.isArray(program.outcomes)      ? program.outcomes      : [];
  const curriculum    = Array.isArray(program.curriculum_outline) ? program.curriculum_outline : [];

  return (
    <div>
      {/* Hero */}
      <section style={{ paddingTop:'calc(var(--nav-h) + clamp(40px,6vw,80px))', paddingBottom:'clamp(40px,6vw,80px)', background:'linear-gradient(160deg, var(--bg-1) 0%, var(--bg-0) 100%)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, background:`radial-gradient(ellipse at 70% 50%, ${color}08 0%, transparent 60%)`, pointerEvents:'none' }}/>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <Link to="/academy" style={{ fontSize:'0.82rem', color:'var(--t-muted)', textDecoration:'none', display:'inline-flex', alignItems:'center', gap:6, marginBottom:24 }}>
            Back to  Programs
          </Link>
          <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) 260px', gap:40, alignItems:'start' }}>
            <div>
              {/* Badges */}
              <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:16 }}>
                <span style={{ padding:'4px 12px', borderRadius:20, fontSize:'0.7rem', fontWeight:700, textTransform:'capitalize', background:`${color}18`, color, border:`1px solid ${color}33` }}>
                  {program.program_type || program.type}
                </span>
                {program.delivery_mode && (
                  <span style={{ padding:'4px 12px', borderRadius:20, fontSize:'0.7rem', fontWeight:600, background:'var(--bg-2)', color:'var(--t-muted)', border:'1px solid var(--border)' }}>
                    {MODE_ICONS[program.delivery_mode] || program.delivery_mode}
                  </span>
                )}
                {program.domain_name && (
                  <span style={{ padding:'4px 12px', borderRadius:20, fontSize:'0.7rem', background:'var(--bg-2)', color:'var(--t-muted)', border:'1px solid var(--border)' }}>
                    {program.domain_name}
                  </span>
                )}
                {(program.fees_info === 'Free' || program.is_free) && (
                  <span style={{ padding:'4px 12px', borderRadius:20, fontSize:'0.7rem', fontWeight:700, background:'rgba(62,207,142,0.12)', color:'#3ecf8e', border:'1px solid rgba(62,207,142,0.3)' }}>Free</span>
                )}
              </div>

              <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(1.8rem,4vw,2.6rem)', fontWeight:700, lineHeight:1.2, marginBottom:16 }}>{program.title}</h1>
              {program.description && (
                <p style={{ fontSize:'1rem', color:'var(--t-secondary)', lineHeight:1.8, maxWidth:620, marginBottom:24 }}>{program.description}</p>
              )}

              {/* Quick stats */}
              <div style={{ display:'flex', gap:24, flexWrap:'wrap' }}>
                {program.duration && (
                  <div>
                    <div style={{ fontSize:'0.65rem', color:'var(--t-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:4 }}>Duration</div>
                    <div style={{ fontWeight:600, fontSize:'0.95rem' }}>{program.duration}</div>
                  </div>
                )}
                {program.fees_info && (
                  <div>
                    <div style={{ fontSize:'0.65rem', color:'var(--t-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:4 }}>Investment</div>
                    <div style={{ fontWeight:600, fontSize:'0.95rem', color:color }}>{program.fees_info}</div>
                  </div>
                )}
                {upcoming.length > 0 && (
                  <div>
                    <div style={{ fontSize:'0.65rem', color:'var(--t-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:4 }}>Next Cohort</div>
                    <div style={{ fontWeight:600, fontSize:'0.95rem', color:'#3ecf8e' }}>
                      {new Date(upcoming[0].start_date).toLocaleDateString('en-RW', { month:'long', day:'numeric', year:'numeric' })}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Enroll CTA card */}
            <div style={{ background:'var(--bg-2)', border:`1px solid ${color}33`, borderRadius:'var(--r-xl)', padding:24, minWidth:260, flexShrink:0 }}>
              {src && (
                <div style={{ height:160, borderRadius:'var(--r-md)', overflow:'hidden', marginBottom:20 }}>
                  <img src={src} alt={program.title} style={{ width:'100%', height:'100%', objectFit:'cover' }}
                    onError={e => e.target.parentNode.style.display='none'}/>
                </div>
              )}
              <div style={{ fontSize:'0.8rem', color:'var(--t-muted)', marginBottom:8 }}>
                {upcoming.length > 0 ? `${upcoming.length} upcoming cohort${upcoming.length > 1 ? 's' : ''}` : 'Applications open'}
              </div>
              <button onClick={() => navigate(`/academy/programs/${program.slug}/apply`)}
                className="btn btn-primary" style={{ width:'100%', justifyContent:'center', background:color, color:'#080a0d', marginBottom:10 }}>
                {program.status === 'open' || program.status === 'ongoing' ? 'Enroll Now' : 'Express Interest'}
              </button>
              <Link to="/contact" style={{ display:'block', textAlign:'center', fontSize:'0.82rem', color:'var(--t-muted)', textDecoration:'none' }}>
                Have questions? Contact us 
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Body */}
      <section style={{ padding:'clamp(40px,6vw,80px) 0' }}>
        <div className="container" style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) 300px', gap:40, alignItems:'start' }}>
          <style>{`@media(max-width:860px){.prog-grid{grid-template-columns:1fr!important}}`}</style>

          {/* Left column */}
          <div style={{ display:'flex', flexDirection:'column', gap:48 }}>

            {/* Description fallback when no structured content */}
            {objectives.length === 0 && outcomes.length === 0 && curriculum.length === 0 && program.description && (
              <div>
                <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.3rem', fontWeight:700, marginBottom:16, color }}>About This Program</h2>
                <p style={{ fontSize:'0.95rem', color:'var(--t-secondary)', lineHeight:1.8 }}>{program.description}</p>
                {program.certification && (
                  <div style={{ marginTop:20, padding:'14px 18px', background:`${color}08`, border:`1px solid ${color}22`, borderRadius:8, borderLeft:`3px solid ${color}` }}>
                    <div style={{ fontSize:'0.7rem', color, textTransform:'uppercase', letterSpacing:'0.08em', fontWeight:700, marginBottom:6 }}>Certification</div>
                    <p style={{ fontSize:'0.88rem', color:'var(--t-secondary)', lineHeight:1.7 }}>{program.certification}</p>
                  </div>
                )}
              </div>
            )}

            {/* Objectives */}
            {objectives.length > 0 && (
              <div>
                <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.3rem', fontWeight:700, marginBottom:20, color:color }}>What You'll Learn</h2>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  {objectives.map((obj, i) => (
                    <div key={i} style={{ display:'flex', gap:10, alignItems:'flex-start', padding:'12px 14px', background:'var(--bg-2)', borderRadius:8, border:'1px solid var(--border)' }}>
                      <span style={{ color:color, marginTop:2, flexShrink:0 }}>â—ˆ</span>
                      <span style={{ fontSize:'0.88rem', color:'var(--t-secondary)', lineHeight:1.5 }}>{obj}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Outcomes */}
            {outcomes.length > 0 && (
              <div>
                <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.3rem', fontWeight:700, marginBottom:20 }}>Program Outcomes</h2>
                <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                  {outcomes.map((out, i) => (
                    <div key={i} style={{ display:'flex', gap:12, alignItems:'flex-start' }}>
                      <span style={{ color:'#3ecf8e', fontWeight:700, flexShrink:0, marginTop:2 }}>âœ“</span>
                      <span style={{ fontSize:'0.92rem', color:'var(--t-secondary)', lineHeight:1.6 }}>{out}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Curriculum */}
            {curriculum.length > 0 && (
              <div>
                <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.3rem', fontWeight:700, marginBottom:20 }}>Curriculum</h2>
                <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                  {curriculum.map((item, i) => (
                    <div key={i} style={{ display:'flex', gap:16, alignItems:'center', padding:'14px 18px', background: i%2===0 ? 'var(--bg-2)' : 'transparent', borderRadius:8 }}>
                      <span style={{ width:24, height:24, borderRadius:'50%', background:`${color}18`, border:`1px solid ${color}33`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.7rem', fontWeight:700, color, flexShrink:0 }}>{i+1}</span>
                      <span style={{ fontSize:'0.9rem', color:'var(--t-secondary)' }}>{typeof item === 'string' ? item : item.title || item.topic || JSON.stringify(item)}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Target audience & requirements */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
              {program.target_audience && (
                <div style={{ padding:'20px 22px', background:'var(--bg-2)', borderRadius:'var(--r-lg)', border:'1px solid var(--border)' }}>
                  <h3 style={{ fontFamily:'var(--font-display)', fontSize:'0.95rem', fontWeight:700, marginBottom:10 }}>Who Is This For?</h3>
                  <p style={{ fontSize:'0.875rem', color:'var(--t-secondary)', lineHeight:1.7 }}>{program.target_audience}</p>
                </div>
              )}
              {program.entry_requirements && (
                <div style={{ padding:'20px 22px', background:'var(--bg-2)', borderRadius:'var(--r-lg)', border:'1px solid var(--border)' }}>
                  <h3 style={{ fontFamily:'var(--font-display)', fontSize:'0.95rem', fontWeight:700, marginBottom:10 }}>Entry Requirements</h3>
                  <p style={{ fontSize:'0.875rem', color:'var(--t-secondary)', lineHeight:1.7 }}>{program.entry_requirements}</p>
                </div>
              )}
            </div>
          </div>

          {/* Right sidebar */}
          <div style={{ display:'flex', flexDirection:'column', gap:20, position:'sticky', top:'calc(var(--nav-h) + 24px)' }}>

            {/* Cohorts */}
            {cohorts.length > 0 && (
              <div style={{ background:'var(--bg-2)', border:'1px solid var(--border)', borderRadius:'var(--r-lg)', overflow:'hidden' }}>
                <div style={{ padding:'14px 18px', borderBottom:'1px solid var(--border)', fontFamily:'var(--font-display)', fontWeight:600, fontSize:'0.9rem' }}>
                  Available Cohorts
                </div>
                {cohorts.map(c => (
                  <div key={c.id} style={{ padding:'14px 18px', borderBottom:'1px solid var(--border-subtle)', display:'flex', flexDirection:'column', gap:6 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <span style={{ fontWeight:600, fontSize:'0.88rem' }}>{c.cohort_name}</span>
                      <span style={{ fontSize:'0.65rem', fontWeight:700, padding:'2px 8px', borderRadius:20,
                        background: c.status==='upcoming' ? 'rgba(62,207,142,0.12)' : 'rgba(107,114,128,0.12)',
                        color: c.status==='upcoming' ? '#3ecf8e' : '#6b7280',
                        border: `1px solid ${c.status==='upcoming' ? 'rgba(62,207,142,0.3)' : 'rgba(107,114,128,0.2)'}`,
                        textTransform:'capitalize'
                      }}>{c.status}</span>
                    </div>
                    {c.start_date && (
                      <div style={{ fontSize:'0.8rem', color:'var(--t-muted)' }}>
                        {new Date(c.start_date).toLocaleDateString('en-RW', { day:'numeric', month:'short', year:'numeric' })}
                        {c.end_date && `  ${new Date(c.end_date).toLocaleDateString('en-RW', { day:'numeric', month:'short' })}`}
                      </div>
                    )}
                    {c.location && <div style={{ fontSize:'0.78rem', color:'var(--t-muted)' }}> {c.location}</div>}
                    <div style={{ display:'flex', justifyContent:'space-between', fontSize:'0.78rem', color:'var(--t-muted)' }}>
                      {c.max_capacity && <span>{c.enrolled || 0}/{c.max_capacity} enrolled</span>}
                      {!c.is_free && c.fee_amount > 0 && <span style={{ color:color, fontWeight:600 }}>{c.fee_currency} {Number(c.fee_amount).toLocaleString()}</span>}
                      {c.is_free && <span style={{ color:'#3ecf8e', fontWeight:600 }}>Free</span>}
                    </div>
                    {c.status === 'upcoming' && (
                      <button onClick={() => navigate(`/academy/programs/${program.slug}/apply`)}
                        style={{ marginTop:4, padding:'8px', borderRadius:6, fontSize:'0.8rem', fontWeight:600, cursor:'pointer', background:`${color}18`, border:`1px solid ${color}44`, color, transition:'all 0.15s' }}>
                        Enroll in This Cohort
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Program info card */}
            <div style={{ background:'var(--bg-2)', border:'1px solid var(--border)', borderRadius:'var(--r-lg)', padding:'18px' }}>
              <div style={{ fontFamily:'var(--font-display)', fontWeight:600, fontSize:'0.9rem', marginBottom:14 }}>Program Details</div>
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                {[
                  ['Type',      program.program_type || program.type],
                  ['Duration',  program.duration],
                  ['Mode',      program.delivery_mode],
                  ['Domain',    program.domain_name],
                  ['Fees',      program.fees_info],
                ].filter(([,v]) => v).map(([k,v]) => (
                  <div key={k} style={{ display:'flex', justifyContent:'space-between', fontSize:'0.82rem' }}>
                    <span style={{ color:'var(--t-muted)' }}>{k}</span>
                    <span style={{ fontWeight:500, textTransform:'capitalize' }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Sponsorship */}
            {program.sponsorship_model && (
              <div style={{ padding:'14px 16px', background:'rgba(232,164,58,0.06)', border:'1px solid rgba(232,164,58,0.2)', borderRadius:'var(--r-md)', fontSize:'0.82rem', color:'var(--t-secondary)' }}>
                <span style={{ color:'var(--gold)', fontWeight:600 }}>ðŸ’¡ Sponsorship: </span>{program.sponsorship_model}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{ background:'var(--bg-1)', borderTop:'1px solid var(--border)', padding:'clamp(40px,5vw,60px) 0' }}>
        <div className="container" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:24, flexWrap:'wrap' }}>
          <div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.4rem', fontWeight:700, marginBottom:8 }}>Ready to enroll?</h2>
            <p style={{ color:'var(--t-secondary)', fontSize:'0.92rem' }}>Secure your spot in the next cohort.</p>
          </div>
          <div style={{ display:'flex', gap:12 }}>
            <button onClick={() => navigate(`/academy/programs/${program.slug}/apply`)}
              className="btn btn-primary" style={{ background:color, color:'#080a0d' }}>
              Enroll Now 
            </button>
            <Link to="/academy" className="btn btn-outline">Browse All Programs</Link>
          </div>
        </div>
      </section>

      
    </div>
  );
}
